module.exports = __webpack_public_path__ + "img/ico-notice1.9f91b8f2.png";